import type React from 'react';
import { useEffect, useState } from 'react';
import type { UpsellGroupProps } from '../../Store/Upsell/state';
import UpsellGroup from './UpsellGroup';
import Slider from '../../../general/Slider/Slider';
import styles from './UpsellOverview.module.scss';
import { sessionStorage } from '../../../../js/util/storage';
import tracker from '../../../general/Tracker/tracker';

interface Props {
  availableUpsellGroups: UpsellGroupProps[];
  parentCartItemId: string;
  parentProductId: number;
}
const UpsellOverview: React.FC<Props> = ({
  availableUpsellGroups,
  parentCartItemId,
  parentProductId,
}) => {
  const [upsellItemsTracked, setUpsellItemsTracked] = useState<boolean>(false);

  useEffect(() => {
    if (upsellItemsTracked === false) {
      const upsellSessionKey = `upsell-views-tracked-${parentCartItemId}-${parentProductId}`;
      const viewTrackedInSession =
        sessionStorage.getItem(upsellSessionKey) === 'true';

      if (viewTrackedInSession === false) {
        availableUpsellGroups.forEach((upsellGroup, numberInList) => {
          upsellGroup.products.forEach((upsellProduct) => {
            tracker.track('Upsell Item Viewed', {
              numberInList: numberInList + 1,
              parentCartItemId,
              parentProductId,
              productId: upsellProduct.id,
              type: 'slider',
            });
          });
        });

        sessionStorage.setItem(upsellSessionKey, 'true');

        setUpsellItemsTracked(true);
      }
    }
  }, [
    upsellItemsTracked,
    parentProductId,
    parentCartItemId,
    availableUpsellGroups,
  ]);

  return (
    <div className={styles.SliderWrapper}>
      <Slider>
        {availableUpsellGroups.map((upsellGroup: UpsellGroupProps) => (
          <UpsellGroup
            parentProductId={parentProductId}
            parentCartItemId={parentCartItemId}
            upsellGroup={upsellGroup}
            key={upsellGroup.id}
          />
        ))}
      </Slider>
    </div>
  );
};

export default UpsellOverview;
